// extracted by mini-css-extract-plugin
export default {"root":"EditLoanDialog_root__SQyl8","address":"EditLoanDialog_address__pb2ow","borrowerRow":"EditLoanDialog_borrowerRow__UhG0Q"};